import React from 'react'
import dayjs from 'dayjs'

import { Input } from '@cvg/react-components'

import { useFiltersContext } from '@contexts/FilterContext'
import { FILTER_DATE_MIN } from '@utils/constants'

import styles from './styles.module.css'

const Dates = () => {
  const { filters, setFilter } = useFiltersContext()

  return (
    <div className={styles.dates}>
      <Input
        type='date'
        label='Start Date'
        name='start-date'
        min={FILTER_DATE_MIN}
        max={dayjs().format('YYYY-MM-DD')}
        value={filters.startDate}
        onChange={e => setFilter({ startDate: e.target.value })}
      />

      <Input
        type='date'
        label='End Date'
        name='end-date'
        min={filters.startDate}
        max={dayjs().format('YYYY-MM-DD')}
        value={filters.endDate}
        onChange={e => setFilter({ endDate: e.target.value })}
      />
    </div>
  )
}

export default Dates
